import { formatViewers } from "./utils/format-number";

export function StreamCard({ stream, onClick }) {
  const imageSrc = stream.thumbnailUrl || stream.hostAvatar || '/images/placeholder.jpg';
  const viewers = formatViewers(stream.currentViewers || 0);

  return (
    <div
      className="relative cursor-pointer w-full"
      onClick={() => onClick(stream._id)}
    >
      <img
        src={imageSrc}
        alt={stream.title}
        className="w-full h-[220px] object-cover rounded-[16px]"
      />

      <div className="absolute top-2 left-2 right-2 flex items-center gap-2">
        <div className="bg-[#CE5D49] rounded-full text-xs font-semibold px-3 py-1 text-white">
          СТРИМ
        </div>

        <p className="text-white font-semibold flex items-center gap-1">
          <img src="/icons/views.png" alt="eye" className="w-5 h-5" />
          {viewers}
        </p>
      </div>

      <div className="mt-2 text-white text-[16px] font-medium truncate">
        {stream.title}
      </div>

      <div className="flex mt-1 items-center gap-2">
        <img
          className="w-6 h-6 rounded-full object-cover"
          src={stream.hostAvatar || '/images/avatar-placeholder.jpg'}
          alt="avatar"
        />
        <p className="text-white text-sm truncate">
          {stream.host?.name || 'Unknown'}
        </p>
      </div>
    </div>
  );
}